import React from 'react';

interface CustomIconProps {
  filled?: boolean;
  color?: string;
}

const TimeRunningClock: React.FC<CustomIconProps> = () => (
  <svg
    width='20'
    height='20'
    viewBox='0 0 20 20'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M10.8334 2.5H14.1667V4.16667H10.8334V2.5ZM2.50002 6.66667H5.83335V8.33333H2.50002V6.66667ZM2.50002 13.3333H5.83335V15H2.50002V13.3333ZM1.66669 10H4.99169V11.6667H1.66669V10ZM18.0892 5.58917L16.9109 4.41083L15.4884 5.83333C14.5868 5.28846 13.5535 5.00031 12.5 5C9.28419 5 6.66669 7.6175 6.66669 10.8333C6.66669 14.0492 9.28419 16.6667 12.5 16.6667C15.7159 16.6667 18.3334 14.0492 18.3334 10.8333C18.3325 9.37172 17.7805 7.96418 16.7875 6.89167L18.0892 5.58917ZM13.3334 11.6667H11.6667V7.465H13.3334V11.6667Z'
      fill='#F87171'
    />
  </svg>
);

export default TimeRunningClock;
